module.exports = __webpack_public_path__ + "static/img/zhuanli.8159480d.png";